import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Fabric } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { KundeFilter } from 'api/kunde';
import { KundeSearch } from 'components/Kunde/KundeSearch';
import { KundeMailing } from 'components/Kunde/KundeMailing';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { Helmet } from 'react-helmet';

const styles = mergeStyleSets({
    container: {
        marginTop: 10,
        width: '100%',
        height: 'calc(100% - 10px)',
        display: 'grid',
        gridTemplateColumns: '300px 1fr',
        gridColumnGap: 15,
    },
    pivotItem: {
        height: 'calc(100vh - 75px)',
    },
    itemWrapper: {
        height: 'calc(100vh - 75px)',
    },
});

interface MailingViewParams {
    kundeNr?: string;
}

export const MailingView: React.FC = () => {
    const { kundeNr } = useParams<MailingViewParams>();
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);

    const [kundeFilter, setKundeFilter] = React.useState<KundeFilter>({});

    if (!lookupsLoadingFinished) {
        return null;
    }

    return (
        <Fabric className={styles.container}>
            <Helmet>
                <title>Mailing</title>
            </Helmet>
            <KundeSearch
                kundeNr={kundeNr ? parseInt(kundeNr, 10) : null}
                onChangeKundeFilter={(newKundeFilter) => setKundeFilter(newKundeFilter)}
            />
            <KundeMailing kundeFilter={kundeFilter} />
        </Fabric>
    );
};
